export function getLocaleDateString(dateTime: number) {
	return new Date(dateTime)?.toLocaleDateString("de", {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
	});
}
